import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'antd/dist/antd.css';
import 'antd/dist/antd.js';
import config from '../config';


import { store, persistor } from './store/index';
import './index.css';
import App from './App';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <GoogleOAuthProvider clientId={config.googleAuthConfig.clientId}>
      <App />
      </GoogleOAuthProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
